import { create } from 'zustand';
import type { TenantDto, UserDto } from '@livestreamx/shared-types';
import { setAccessToken } from '../lib/api';

interface AuthState {
  user: UserDto | null;
  tenant: TenantDto | null;
  accessToken: string | null;
  loading: boolean;
  setSession: (user: UserDto, tenant: TenantDto | null, accessToken: string, expiresInSeconds?: number) => void;
  setTenant: (tenant: TenantDto | null) => void;
  setLoading: (loading: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  tenant: null,
  accessToken: null,
  loading: true,
  setSession: (user, tenant, accessToken, expiresInSeconds) => {
    setAccessToken(accessToken, expiresInSeconds);
    try {
      // Client-side session hint for fetchMe(): lets the app skip the
      // /auth/me probe entirely when nobody ever logged in (avoids 401 noise).
      // The real session still lives in the HttpOnly refresh cookie.
      localStorage.setItem('lsx_session', '1');
    } catch {
      /* storage unavailable (private mode) — probe will just run */
    }
    set({ user, tenant, accessToken });
  },
  setTenant: (tenant) => set({ tenant }),
  setLoading: (loading) => set({ loading }),
  clear: () => {
    setAccessToken(null);
    try {
      localStorage.removeItem('lsx_session');
    } catch {
      /* ignore */
    }
    set({ user: null, tenant: null, accessToken: null });
  },
}));